<main id="main">
  <router-outlet></router-outlet>
  <app-sso></app-sso>
</main>
<lib-preloader [loading]="loading"></lib-preloader>
